'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _Button = require('./Button.scss');

var _Button2 = _interopRequireDefault(_Button);

var _WixComponent2 = require('../../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _ButtonLayout = require('../../ButtonLayout/ButtonLayout');

var _ButtonLayout2 = _interopRequireDefault(_ButtonLayout);

var _omit = require('omit');

var _omit2 = _interopRequireDefault(_omit);

var _Focusable = require('../../common/Focusable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICON_SIZES = {
  'x-small': '8px',
  small: '8px',
  medium: '12px'
};

var Button = function (_WixComponent) {
  _inherits(Button, _WixComponent);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.addIcon = function (className, icon, height) {
      var iconSize = ICON_SIZES[height] || '16px';
      var dataHook = className === _Button2.default.prefix ? 'btn-prefix' : 'btn-suffix';

      return icon ? _react2.default.createElement(
        'div',
        { className: className, 'data-hook': dataHook },
        _react2.default.cloneElement(icon, { size: iconSize })
      ) : null;
    }, _this.addPrefix = function () {
      return _this.addIcon(_Button2.default.prefix, _this.props.prefixIcon, _this.props.height);
    }, _this.addSuffix = function () {
      return _this.addIcon(_Button2.default.suffix, _this.props.suffixIcon, _this.props.height);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          onClick = _props.onClick,
          children = _props.children,
          type = _props.type,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave;


      var buttonLayoutProps = (0, _omit2.default)(['id', 'onClick', 'prefixIcon', 'suffixIcon', 'type'], this.props);

      return _react2.default.createElement(
        _ButtonLayout2.default,
        buttonLayoutProps,
        _react2.default.createElement(
          'button',
          _extends({
            onClick: onClick,
            disabled: disabled,
            type: type,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: this.props.focusableOnFocus // For some reason eslint react/prop-types rule doesn't work here ?!#$
            , onBlur: this.props.focusableOnBlur
          }, (0, _Focusable.focusableStates)(this.props)),
          this.addPrefix(),
          children,
          this.addSuffix()
        )
      );
    }
  }]);

  return Button;
}(_WixComponent3.default);

Button.displayName = 'Button';
Button.propTypes = _extends({}, _ButtonLayout2.default.propTypes, {
  children: _propTypes.node,
  id: _propTypes.string,
  prefixIcon: _propTypes.node,
  suffixIcon: _propTypes.node,
  type: _propTypes.string,
  onClick: _propTypes.func,
  onMouseEnter: _propTypes.func,
  onMouseLeave: _propTypes.func
});
Button.defaultProps = _ButtonLayout2.default.defaultProps;
exports.default = (0, _Focusable.withFocusable)(Button);